import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';

const initialData = {
  candidatesData: [],
  CandidatesDataStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'nbMaintenance',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getcandidatesData: (state, action) => {
      state.candidatesData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
    approveBatch: (state, action) => {
      state.successMsg = action.payload?.response;
    },
    resetCandidatesData: (state) => {
      state.candidatesData = [];
      state.CandidatesDataStatus = null;
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.CandidatesDataStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetApproveBatchResponse: (state) => {
      state.successMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getcandidatesData,
  resetCandidatesData,
  resetApproveBatchResponse,
  approveBatch,
  fetchStart,
  fetchError,
  resetSuccess,
} = slice.actions;

export const fetchCandidatesData = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`findall/batch/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getcandidatesData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postApproveBatch = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`batch/approve/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(approveBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetCandidates = () => {
  return (dispatch) => {
    dispatch(resetCandidatesData());
  };
};
export const resetApproveBatch = () => {
  return (dispatch) => {
    dispatch(resetApproveBatchResponse());
  };
};

